import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { AsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, RootState } from '../store';

export const useCommand = <Arg>(action: AsyncThunk<void, Arg, { state: RootState }>) => {
    const dispatch = useDispatch<Dispatch>();

    return useCallback(async (arg: Arg) => dispatch(action(arg)), [dispatch]);
};
